import {initPage} from "./init-page";
import {initProductPage} from "./init-product-page";

window.addEventListener(`load`, () => {
  initPage({policyButtonTitle: `Сообщить о поступлении`});
  initProductPage(shopInfoData, itemData);
});
